import type { Tenant } from '#/graphql/types';
import type { Field } from '#/common/components/Form';
import type { Key } from '#/types';
import { RequiredRule } from 'devextreme-react/validator';
import FieldDefs from '#/types/FieldDefs';

const fields = {
  id: {
    dataField: 'id',
    label: 'ID',
    editorOptions: { readOnly: true },
  },
  name: {
    dataField: 'name',
    label: 'Name',
    isRequired: true,
    children: [<RequiredRule key="name-required" message="Name is required" />],
  },
  address: {
    dataField: 'address',
    label: 'Address',
    editorType: 'TextArea',
  },
  contacts: {
    dataField: 'contacts',
    label: 'Contacts',
    editorType: 'TextArea',
  },
  isActive: {
    dataField: 'isActive',
    label: 'Active',
    editorType: 'CheckBox',
  },
  cognitoGroupName: {
    dataField: 'cognitoGroupName',
    label: 'Cognito Group Name',
  },
  tisId: {
    dataField: 'tisId',
    label: 'TIS ID',
    editorOptions: { readOnly: true },
  },
  plan: {
    dataField: 'plan',
    label: 'Plan',
    editorType: 'SelectBox',
    editorOptions: {
      items: [
        { key: 'starter', label: 'Starter' },
        { key: 'basic', label: 'Basic' },
        { key: 'professional', label: 'Professional' },
        { key: 'enterprise', label: 'Enterprise' },
        { key: 'max', label: 'Max' },
      ],
      displayExpr: 'label',
      valueExpr: 'key',
    },
  },
} satisfies FieldDefs<Tenant>;

export default fields;
